import Vue from 'vue';
import { Promised } from 'vue-promised';
import i18n from '@/api/i18n/i18n';
import App from './application.vue';
import router from './router';
import store from './store';
import './register-service-worker';
import 'reset-css';
import '@/assets/styles/index.css';
import '@/assets/styles/transitions.css';
import 'vue2-datepicker/index.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import 'vue-select/src/scss/vue-select.scss';
import 'vue-toast-notification/dist/theme-default.css';

Vue.component('promised', Promised);

Vue.config.productionTip = false;

store
  .dispatch('init')
  .finally(() => {
    new Vue({
      router,
      store,
      i18n,
      render: (h) => h(App),
    }).$mount('#app');
  });
